export enum DateFormats {
  DataBase = 'yyyy-MM-dd HH:mm:ss.SSS',
  UTC = 'yyyy-MM-dd 00:00:00.000',
  NumericUS = 'MMM-dd',
  Report = 'M-d-yy',
}
